import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal = _resolveComponent("app-modal")!

  return (_openBlock(), _createBlock(_component_app_modal, {
    name: _ctx.DIALOG_NAME,
    visible: _ctx.dialog.visible
  }, {
    default: _withCtx(() => [
      _createElementVNode("h5", null, _toDisplayString(_ctx.dialog.title), 1),
      _hoisted_1,
      _createElementVNode("p", null, _toDisplayString(_ctx.dialog.message), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "ml-1 btn btn-md btn-primary",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.submit(true)), ["prevent"]))
        }, _toDisplayString(_ctx.dialog.confirmText), 1),
        _createElementVNode("button", {
          class: "ml-1 btn btn-md btn-secondary",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit(false)), ["prevent"]))
        }, _toDisplayString(_ctx.dialog.cancelText), 1)
      ])
    ]),
    _: 1
  }, 8, ["name", "visible"]))
}